import { render, staticRenderFns } from "./ModalVisualizarInscripciones.vue?vue&type=template&id=0bbd6918&scoped=true"
import script from "./ModalVisualizarInscripciones.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarInscripciones.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarInscripciones.vue?vue&type=style&index=0&id=0bbd6918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd6918",
  null
  
)

export default component.exports